'use strict';

exports.__esModule = true;

var _BaseGoogleAnalyticsEvent = require('./BaseGoogleAnalyticsEvent');

var _BaseGoogleAnalyticsEvent2 = _interopRequireDefault(_BaseGoogleAnalyticsEvent);

var _constants = require('../constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _constants$events$off = _constants2.default.events.offerRedemption,
    DATALAYER_EVENT_NAME = _constants$events$off.DATALAYER_EVENT_NAME,
    OFFER_REDEMPTION = _constants$events$off.OFFER_REDEMPTION,
    MANUAL = _constants$events$off.MANUAL;

var ManualOfferRedemptionEvent = function (_BaseGoogleAnalyticsE) {
    _inherits(ManualOfferRedemptionEvent, _BaseGoogleAnalyticsE);

    function ManualOfferRedemptionEvent(_ref) {
        var offerTitle = _ref.offerTitle;

        _classCallCheck(this, ManualOfferRedemptionEvent);

        return _possibleConstructorReturn(this, _BaseGoogleAnalyticsE.call(this, {
            gtmEventName: DATALAYER_EVENT_NAME,
            category: OFFER_REDEMPTION,
            action: MANUAL,
            label: offerTitle
        }));
    }

    return ManualOfferRedemptionEvent;
}(_BaseGoogleAnalyticsEvent2.default);

exports.default = ManualOfferRedemptionEvent;
;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/providers/googleTagManager/events/ManualOfferRedemptionEvent.js
// module id = 854
// module chunks = 0